import { call } from 'redux-saga/effects';
import getPrice from './getPrice';


export default function* updatePrice(action) {
  yield call(getPrice, action.payload);
}
